module.exports = {
    isOnSale: function () {
        var hasVariantOnSale = this.get('variants').findWhere({ on_sale: true});
        if (hasVariantOnSale) {
            return true;
        } else {
          return false;
        }
    },
    isOnClearance: function () {
      var hasVariantOnClearance = this.get('variants').findWhere({ on_clearance: true});
      if (hasVariantOnClearance) {
          return true;
      } else {
        return false;
      }
    },
    isFarmExclusive: function () {
        return this.get('is_farm_exclusive') == 1;
    },
    isBCGrown: function () {
        return this.get('is_bc_grown') == 1;
    },
    isOrganic: function () {
        return this.get('is_organic') == 1;
    },
    isVegan: function () {
        return this.get('is_vegan') == 1;
    },
    isSeasonal: function () {
        return this.get('is_seasonal') == 1;
    },
    isSugarFree: function () {
        return this.get('is_sugar_free') == 1;
    },
    isHighCBD: function () {
        return this.get('is_high_cbd') == 1;
    },
    isHighCBN: function () {
        return this.get('is_high_cbn_cbg') == 1 || this.get('is_high_cbn') == 1;
    },
    isHighCBG: function () {
        return this.get('is_high_cbg') == 1;
    },
    getStrainGroupCode: function () {
        var strainGroup = this.get('strain_group');
        if (strainGroup) {
            return strainGroup.get('code');
        }
        return '';
    },
    getProductImage: function (useFirstWhenNoPrimary) {
        useFirstWhenNoPrimary = _.isUndefined(useFirstWhenNoPrimary) ? useFirstWhenNoPrimary : true;
        var images = this.get('images');
        if (images) {
          var primaryImage = images.findWhere({ is_primary: '1' });
          if (primaryImage) {
              return primaryImage;
          } else if (useFirstWhenNoPrimary && images.size()) {
              return images.at(0);
          } else {
              return null;
          }
        } else {
          return null;
        }
    },
    getProductImageURL: function (sizeName, useFirstWhenNoPrimary) {
        useFirstWhenNoPrimary = _.isUndefined(useFirstWhenNoPrimary) ? useFirstWhenNoPrimary : true;
        var productImage = this.getProductImage(useFirstWhenNoPrimary)
        if (productImage) {
            return productImage.get(sizeName + '_url');
        }
        return '';
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/admin-app/entities/product-mixin.js
 **/